import { useTranslation } from 'react-i18next';
import Modal from './Modal';

export default function ConfirmDialog({ title, message, confirmLabel, cancelLabel, confirmClass = 'btn-danger', onConfirm, onCancel, loading }) {
  const { t } = useTranslation();
  return (
    <Modal
      title={title}
      onClose={onCancel}
      footer={
        <>
          <button className="btn btn-secondary" onClick={onCancel} disabled={loading}>{cancelLabel ?? t('common.cancel')}</button>
          <button className={`btn ${confirmClass}`} onClick={onConfirm} disabled={loading}>
            {loading ? <span className="spinner" /> : (confirmLabel ?? t('common.confirm'))}
          </button>
        </>
      }
    >
      <p style={{ color: 'var(--text-secondary)' }}>{message}</p>
    </Modal>
  );
}
